<template>
    <div class="my_footer" style="position: relative;">
        <img v-if="newPath == '/gywm' || newPath == '/swhz' || newPath == '/xwzx'"
            src="../../assets/img/lufei/img_footer_angle_gray.png" class="sanjiao  " alt="">
        <!-- <img v-else-if="newPath == '/swhz'" src="../../assets/img/lufei/img_footer_angle_gray.png" class="sanjiao  "
            alt=""> -->
        <img v-else src="../../assets/img/lufei/img_footer_angle_white.png" class="sanjiao  " alt="">
        <div class="cen">
            <div class="cen_top">
                <div class="cen_top_left">
                    <img src="../../assets/img/lufei/ico_top_logo.png" class="logo1  " alt="">
                    <!-- <img src="../../assets/img/lufei/ico_top_logo.png" class="logo1" alt=""
                        style="width: 236px;height: 61px;     transform: scale(calc(1920 / 2200), 1) !important;"> -->
                    <div class="cen_top_left_line  "></div>
                    <div class="cen_top_left_txt   SourceHanSansCN-Regular">建设科技中国，鲁飞与您一路同行！</div>
                </div>
                <div class="cen_top_right">
                    <img src="../../assets/img/lufei/ico_footer_tel.png" class="telImg  " alt="">
                    <div class="cen_top_right_txt  SourceHanSansCN-Regular">400-088-1181</div>
                </div>
            </div>
            <div class="cen_bottom">
                <div class="cen_bottom_item" v-for="(item, index) in navList" :key="index">
                    <div class="cen_bottom_item_title">{{ item.title }}</div>
                    <div class="cen_bottom_item_txt">
                        <template v-for="(card, index1) in item.cardlist">
                            <img v-if="card.img" :src="card.img" alt="">
                            <!-- <a href="#" :class="{ a_class: card.img }">{{ card.menuName }}</a> -->
                            <router-link :to="card.link" class="a_class">{{ card.menuName }}</router-link>
                        </template>
                        <!-- <a href="#">石油石化行业安防解决方案</a>
                        <a href="#">智慧安防</a>
                        <a href="#">智慧园区</a>
                        <a href="#">加油站数据管理云平台</a>
                        <a href="#">石油石化行业安防解决方案</a>
                        <a href="#">加油站数据管理云平台</a>
                        <a href="#">石油石化行业安防解决方案</a> -->
                    </div>
                </div>
                <!-- <div class="cen_bottom_item">
                    <div class="cen_bottom_item_title">产品中心</div>
                    <div class="cen_bottom_item_txt">
                        <a href="#">产品中心</a>
                        <a href="#">产品展示</a>
                        <a href="#">新闻资讯</a>
                    </div>
                </div>
                <div class="cen_bottom_item">
                    <div class="cen_bottom_item_title">新闻中心</div>
                    <div class="cen_bottom_item_txt">
                        <a href="#">产品中心</a>
                        <a href="#">产品展示</a>
                        <a href="#">新闻资讯</a>
                    </div>
                </div>
                <div class="cen_bottom_item">
                    <div class="cen_bottom_item_title">关于鲁飞</div>
                    <div class="cen_bottom_item_txt">
                        <a href="#">产品中心</a>
                        <a href="#">产品展示</a>
                        <a href="#">新闻资讯</a>
                    </div>
                </div>
                <div class="cen_bottom_item">
                    <div class="cen_bottom_item_title">招贤纳士</div>
                    <div class="cen_bottom_item_txt">
                        <a href="#">产品中心</a>
                        <a href="#">产品展示</a>
                        <a href="#">新闻资讯</a>
                    </div>
                </div>
                <div class="cen_bottom_item">
                    <div class="cen_bottom_item_title">招贤纳士</div>
                    <div class="cen_bottom_item_txt" style="text-align: center;">
                        <img style="" src="" alt="">
                        <a href="#" style="text-align: left;
    padding-left: 20px;">关注我们</a>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="bottom">
            <div class="w1400 clearfix flex-row" style="justify-content: center;">
                <div class="bottom_txt">北京鲁飞御航高科技有限公司</div>
                <div class="bottom_txt" style="margin: 0 30px;">Copyright@2002-2023 北京鲁飞御航高科技有限公司 版权所有</div>
                <div class="bottom_txt">备案号：</div>
                <a class="bottom_txt" href="//beian.miit.gov.cn/" target="_blank" rel="noopener">京ICP备2026007814号-1</a>
                <a class="bottom_txt bottom_txt_left"
                    href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502059802" target="_blank"
                    rel="noopener">京公网安备11010502059802号</a>
                <!-- <div @click="go" class="cur ">鲁ICP备20022425号</div> -->
            </div>
        </div>
    </div>
</template>
<script>
import { listBjlfmenu } from "@/api/system/bjlfmenu";// 菜单接口
export default {
    name: 'LufeidemoFooter',

    data() {
        return {
            newPath: '',
            // currentFooterImage: '',
            navList: [{
                title: '产品中心',
                cardlist: [

                ],
            },
            {
                title: '解决方案',
                cardlist: [

                ],
            }, {
                title: '新闻中心',
                cardlist: [

                ],
            }, {
                title: '关于鲁飞',
                cardlist: [
                    {
                        menuName: '企业简介',
                        link: '/gywm'
                    },
                    {
                        menuName: '企业文化',
                        link: '/gywm'
                    },
                    {
                        menuName: '发展历程',
                        link: '/gywm'
                    },
                    {
                        menuName: '资质荣誉',
                        link: '/gywm'
                    }, {
                        menuName: '联系我们',
                        link: '/gywm'
                    },
                ],
            }, {
                title: '招贤纳士',
                cardlist: [
                    {
                        menuName: '岗位招聘',
                        link: '/swhz'
                    }
                ],
            }, {
                title: '关注我们',
                // menuName
                cardlist: [
                    {
                        menuName: '微信公众号',
                        img: require('../../assets/img/home1/rwm1.jpg'),
                        link: ''
                    }
                ],
            },
            ],
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10000,
                menuName: null,
                parentId: null,
                orderNum: null,
            },
        };
    },
    watch: {
        '$store.state.lufei.productList': {
            handler(val) {
                this.navList[0].cardlist = val;
            },
            deep: true,
        },
        // 监听路由路径变化（$route.path 是当前路由的路径）
        '$route.path'(newPath) {
            // console.log('路由变化：', newPath)
            this.newPath = newPath;
            // this.currentFooterImage = this.getImageByRoute(newPath);
        },
    },
    mounted() {
        // console.log('Footer组件mounted')
        // console.log(this.$route.path)
        this.newPath = this.$route.path;
        // this.navList[0].cardlist = this.$store.state.lufei.productList;
        //读取菜单列表
        this.getBjlfmenuList();
    },

    methods: {
        go() {
            window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank');
        },
        // 读取菜单的列表
        getBjlfmenuList() {
            listBjlfmenu(this.queryParams).then(res => {
                this.bjlfmenuList = this.handleTree(res.rows, "menuId");
                // console.log(this.bjlfmenuList, '菜单列表11111113333')
                this.navList[1].cardlist = this.bjlfmenuList[2].children;
                this.navList[0].cardlist = this.bjlfmenuList[1].children;
                this.navList[2].cardlist = this.bjlfmenuList[3].children;
                // this.navList[3].cardlist = [

                // ];
                // this.navList[4].cardlist = this.bjlfmenuList[5].children;
                // this.productMaxValue = this.bjlfmenuList[1].children.length;// 产品中心
                // this.schemeMaxValue = this.bjlfmenuList[2].children.length;//解决方案
                // // console.log(this.bjlfmenuList[2].children, '0000000000000000')
                // // 默认加载一次解决方案
                // this.showDetail(this.bjlfmenuList[2].children[0].menuId);
                // this.bjlfmenuList[1].children.forEach((item, index) => {
                // })

            })
        },
    },
};
</script>
<style lang="less" scoped>
.my_footer {
    width: 100%;
    /* height: 453px; */
    background: rgba(37, 41, 52, 1);
    color: #fff;
    position: relative;

    .sanjiao {
        position: absolute;
        right: 300px;
        top: -2px;
    }

    .cen {
        background: #06192F;
        padding: 0 294px 0 260px;
        box-sizing: border-box;

        .cen_top {
            display: flex;
            justify-content: space-between;
            padding-top: 92px;
            padding-bottom: 37px;
            border-bottom: 1px solid rgba(255, 255, 255, .1);
            box-sizing: border-box;


            .cen_top_left {
                display: flex;
                align-items: center;
                gap: 40px;

                .logo1 {
                    width: 236px;
                    height: 61px;
                }

                .cen_top_left_line {
                    width: 1px;
                    height: 31px;
                    background: #FFFFFF;
                }

                .cen_top_left_txt {
                    font-weight: 400;
                    font-size: 24px;
                    color: #FFFFFF;
                }
            }

            .cen_top_right {
                display: flex;
                gap: 20px;

                .telImg {
                    width: 39px;
                    height: 39px;
                }

                .cen_top_right_txt {
                    letter-spacing: 2px;
                    font-weight: bold;
                    font-size: 30px;
                    color: #FFFFFF;
                }
            }
        }

        .cen_bottom {

            ::v-deep a,
            img {
                display: block;
            }

            padding-top: 66px;
            padding-bottom: 80px;
            box-sizing: border-box;
            display: flex;
            align-items: flex-start;
            gap: 38px;
            flex-shrink: 0 !important;

            .cen_bottom_item {
                flex: 1;

                // text-align: center;
                .cen_bottom_item_title {
                    font-weight: bold;
                    font-size: 18px;
                    color: #FFFFFF;
                    margin-bottom: 30px;
                    font-family: SourceHanSansCN-Regular;
                }

                .cen_bottom_item_txt {
                    font-weight: 400;
                    font-size: 14px;
                    color: #FFFFFF;
                    line-height: 40px;
                    opacity: 0.5;
                    font-family: SourceHanSansCN-Regular;

                    img {
                        width: 100px;
                        height: 100px;
                        margin-bottom: 10px;
                    }

                    a {}

                    .a_class {
                        text-align: left;
                        // padding-left: 10px;
                        white-space: nowrap;
                        /* 不换行 */
                        overflow: hidden;
                        /* 超出隐藏 */
                        text-overflow: ellipsis;
                        /* 显示省略号... */
                        width: 200px;
                        /* 必须给宽度！ */
                    }
                }
            }

        }
    }

    .bottom {
        font-family: SourceHanSansCN-Regular;
        background: #041324;
        height: 60px;
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 60px;
        letter-spacing: 1px;

        .bottom_txt {
            opacity: .5;
        }

        .bottom_txt_left {
            margin-left: 30px;
        }

        a {
            font-size: 12px;
            font-weight: 400;
            color: #FFFFFF;

        }
    }
}
</style>